export default "__VITE_ASSET__48d23e99__"